module.exports = __webpack_public_path__ + "static/media/25.e4154932.jpg";